<nz-layout class="revision-detail-layout">
  <nz-header>
    <nz-tabset nzType="card" [nzTabBarExtraContent]="extraTemplate">
      <nz-tab [nzTitle]="titleTemplate">
        <ng-template #titleTemplate>
          <div class="tab-title">
            <button
              nz-button
              nzType="text"
              (click)="goBack(); $event.stopPropagation()"
              class="back-button">
              <span
                nz-icon
                nzType="arrow-left"
                nzTheme="outline"
                class="back-icon"></span>
            </button>
            <span>Revisão — {{ (detail?.chassis || '') | uppercase }}</span>
          </div>
        </ng-template>
      </nz-tab>
    </nz-tabset>

    <ng-template #extraTemplate>
      <div class="header-actions">
        <button
          nz-button
          nzType="default"
          class="action-btn"
          (click)="exportToPdf()"
          [disabled]="!detail">
          <i nz-icon nzType="file-pdf"></i>
          Exportar PDF
        </button>
        <ng-container *hasPermission="'ADMIN'">
          <button
            *ngIf="detail && !detail.is_configured"
            nz-button
            nzType="primary"
            class="action-btn"
            (click)="openConfigureModal()">
            <i nz-icon nzType="setting"></i>
            Configurar
          </button>
          <ng-container *ngIf="detail?.is_configured">
            <button
              nz-button
              nzType="default"
              class="action-btn"
              (click)="openIntervalModal()">
              <i nz-icon nzType="edit"></i>
              Intervalo
            </button>
            <button
              nz-button
              nzType="primary"
              class="action-btn action-btn--register"
              (click)="openRegisterModal()">
              <i nz-icon nzType="check"></i>
              Registrar revisão
            </button>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </nz-header>

  <nz-content>
    <nz-spin [nzSpinning]="loading">
      <div class="revision-detail-body" *ngIf="detail">
        <div class="vehicle-hero">
          <div class="vehicle-hero__media">
            <az_avatar
              [fullHeight]="true"
              [fullWidth]="true"
              [shape]="'square'"
              [src]="detail.product_image || undefined"
              icon="directions_car"></az_avatar>
          </div>

          <div class="vehicle-hero__info">
            <div class="vehicle-hero__title-row">
              <div>
                <p class="vehicle-hero__eyebrow">Relatório de revisão</p>
                <h1>{{ detail.product_name || 'Veículo' }}</h1>
                <p class="vehicle-hero__plate">{{ detail.chassis | uppercase }}</p>
              </div>
              <nz-tag
                class="status-tag"
                [nzColor]="getStatusColor(detail.revision_status)">
                {{ getStatusLabel(detail.revision_status) }}
              </nz-tag>
            </div>

            <p class="vehicle-hero__meta">
              <i nz-icon nzType="calendar"></i>
              Último checklist:
              {{
                detail.last_checklist_at
                  ? (detail.last_checklist_at | date: 'dd/MM/yyyy HH:mm')
                  : '-'
              }}
            </p>
          </div>
        </div>

        <div [class]="getHeroCardClass()">
          <i nz-icon nzType="dashboard" class="hero-card__icon"></i>
          <div class="hero-card__content">
            <span class="hero-card__label">{{ getKmHighlightLabel() }}</span>
            <strong class="hero-card__value">{{ getKmHighlightValue() }}</strong>
            <span class="hero-card__sub">{{ getKmHighlightSubtext() }}</span>
          </div>
        </div>

        <div class="metrics-grid">
          <div class="metric-card">
            <span class="metric-card__label">KM atual</span>
            <strong class="metric-card__value">
              {{ detail.current_km | number: '1.0-0' }}
            </strong>
            <span class="metric-card__unit">km · via checklist</span>
          </div>

          <div class="metric-card">
            <span class="metric-card__label">Última revisão</span>
            <strong class="metric-card__value">
              {{
                detail.last_revision_km !== null
                  ? (detail.last_revision_km | number: '1.0-0')
                  : '—'
              }}
            </strong>
            <span class="metric-card__unit">km</span>
          </div>

          <div class="metric-card">
            <span class="metric-card__label">Intervalo</span>
            <strong class="metric-card__value">
              {{
                detail.revision_interval_km !== null
                  ? (detail.revision_interval_km | number: '1.0-0')
                  : '—'
              }}
            </strong>
            <span class="metric-card__unit">km entre revisões</span>
          </div>

          <div
            class="metric-card metric-card--accent"
            [class.metric-card--danger]="
              detail.revision_status === RevisionStatusEnum.OVERDUE
            ">
            <span class="metric-card__label">Próxima revisão</span>
            <strong class="metric-card__value">
              {{
                detail.next_revision_km !== null
                  ? (detail.next_revision_km | number: '1.0-0')
                  : '—'
              }}
            </strong>
            <span class="metric-card__unit">km previstos</span>
          </div>
        </div>

        <div class="progress-panel" *ngIf="detail.is_configured">
          <div class="progress-panel__header">
            <span>Progresso até a próxima revisão</span>
            <strong>{{ getRevisionProgress() }}%</strong>
          </div>
          <nz-progress
            [nzPercent]="getRevisionProgress()"
            [nzShowInfo]="false"
            [nzStrokeColor]="getProgressStrokeColor()"
            nzStrokeWidth="12"></nz-progress>
          <div class="progress-panel__labels">
            <span>{{ detail.last_revision_km | number: '1.0-0' }} km</span>
            <span>{{ detail.next_revision_km | number: '1.0-0' }} km</span>
          </div>
        </div>

        <div class="setup-banner" *ngIf="!detail.is_configured">
          <i nz-icon nzType="info-circle" nzTheme="fill"></i>
          <div>
            <strong>Veículo ainda não configurado</strong>
            <p>
              Informe o KM da última revisão e o intervalo para acompanhar o
              prazo automaticamente.
            </p>
          </div>
        </div>

        <nz-divider></nz-divider>

        <section class="history-section">
          <div class="history-section__header">
            <h3>Histórico de revisões</h3>
            <span class="history-count">{{ detail.history.length }} registro(s)</span>
          </div>

          <nz-table
            *ngIf="detail.history.length > 0"
            [nzData]="detail.history"
            [nzShowPagination]="detail.history.length > 10"
            [nzPageSize]="10"
            nzSize="middle"
            [nzScroll]="{ x: '640px' }"
            class="history-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>KM revisão</th>
                <th>Intervalo vigente</th>
                <th>Registrado por</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of detail.history">
                <td>{{ entry.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>
                  <span class="history-km">
                    {{ entry.revision_km | number: '1.0-0' }} km
                  </span>
                </td>
                <td>{{ entry.interval_km | number: '1.0-0' }} km</td>
                <td>{{ entry.created_by_user_name || '-' }}</td>
              </tr>
            </tbody>
          </nz-table>

          <nz-empty
            *ngIf="detail.history.length === 0"
            nzNotFoundContent="Nenhuma revisão registrada ainda"
            class="history-empty"></nz-empty>
        </section>
      </div>
    </nz-spin>
  </nz-content>
</nz-layout>

<nz-modal
  [(nzVisible)]="showConfigureModal"
  nzTitle="Configuração inicial"
  [nzOkLoading]="saving"
  nzOkText="Salvar"
  nzCancelText="Cancelar"
  (nzOnOk)="saveConfigure()"
  (nzOnCancel)="showConfigureModal = false">
  <ng-container *nzModalContent>
    <p class="modal-hint">
      Informe o KM da última revisão realizada e o intervalo. Feito uma única
      vez — depois use &quot;Registrar revisão&quot; para novas entradas no
      histórico.
    </p>
    <div class="form-row">
      <label>KM da última revisão</label>
      <nz-input-number
        [(ngModel)]="configureLastRevisionKm"
        [nzMin]="0"
        [nzStep]="100"
        style="width: 100%;"></nz-input-number>
    </div>
    <div class="form-row">
      <label>Intervalo de revisão (km)</label>
      <nz-input-number
        [(ngModel)]="configureIntervalKm"
        [nzMin]="1"
        [nzStep]="500"
        style="width: 100%;"></nz-input-number>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="showIntervalModal"
  nzTitle="Alterar intervalo"
  [nzOkLoading]="saving"
  nzOkText="Salvar"
  nzCancelText="Cancelar"
  (nzOnOk)="saveInterval()"
  (nzOnCancel)="showIntervalModal = false">
  <ng-container *nzModalContent>
    <p class="modal-hint">
      O KM atual continua vindo dos checklists. Apenas o intervalo entre
      revisões é alterado.
    </p>
    <div class="form-row">
      <label>Intervalo (km)</label>
      <nz-input-number
        [(ngModel)]="intervalKm"
        [nzMin]="1"
        [nzStep]="500"
        style="width: 100%;"></nz-input-number>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="showRegisterModal"
  nzTitle="Registrar revisão"
  [nzOkLoading]="saving"
  nzOkText="Registrar"
  nzCancelText="Cancelar"
  (nzOnOk)="registerRevision()"
  (nzOnCancel)="showRegisterModal = false">
  <ng-container *nzModalContent>
    <p class="modal-hint">
      Registre o KM em que a revisão foi realizada. Isso atualiza a base e
      adiciona uma linha no histórico.
    </p>
    <div class="form-row">
      <label>KM da revisão realizada</label>
      <nz-input-number
        [(ngModel)]="registerRevisionKm"
        [nzMin]="0"
        [nzStep]="100"
        style="width: 100%;"></nz-input-number>
    </div>
  </ng-container>
</nz-modal>
